import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { FluxoCaixaPage } from './FluxoCaixaPage';
import { TransacoesPage } from './TransacoesPage';
import { ImpostosPage } from './ImpostosPage';
import { SimuladorReformaPage } from './SimuladorReformaPage';
import { PayoutsPage } from './PayoutsPage';
import { FechamentoPage } from './FechamentoPage';
import { ImportacoesListPage } from './ImportacoesListPage';
import { FaturasListPage } from './FaturasListPage';

type TabId =
  | 'fluxo'
  | 'transacoes'
  | 'impostos'
  | 'reforma'
  | 'payouts'
  | 'fechamento'
  | 'importacoes'
  | 'faturas';

const ALL_TABS: { id: TabId; label: string }[] = [
  { id: 'fluxo', label: 'Fluxo de Caixa' },
  { id: 'transacoes', label: 'Transações' },
  { id: 'importacoes', label: 'Importações' },
  { id: 'faturas', label: 'Faturas de Cartão' },
  { id: 'impostos', label: 'Impostos' },
  { id: 'reforma', label: 'Reforma Tributária' },
  { id: 'payouts', label: 'Repasses Stripe' },
  { id: 'fechamento', label: 'Fechamento Mensal' },
];

export function FinanceiroPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'ADMIN';
  const [params, setParams] = useSearchParams();

  const requestedTab = (params.get('tab') as TabId) || 'fluxo';
  const tab: TabId = ALL_TABS.some((t) => t.id === requestedTab) ? requestedTab : 'fluxo';

  function setTab(id: TabId) {
    const next = new URLSearchParams(params);
    next.set('tab', id);
    setParams(next, { replace: true });
  }

  if (!isAdmin) {
    return <div className="p-6 text-ink-secondary">Acesso restrito a administradores.</div>;
  }

  return (
    <div className="space-y-6">
      <div className="px-6 pt-6">
        <h1 className="text-2xl font-semibold text-ink">Financeiro</h1>
        <p className="text-sm text-ink-secondary mt-1">
          Gestão financeira operacional — fluxo de caixa, impostos, repasses e fechamento mensal.
        </p>
      </div>

      <nav className="flex gap-1 border-b border-border px-6 sticky top-0 bg-canvas/80 backdrop-blur z-10">
        {ALL_TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`text-sm px-4 py-2 -mb-px border-b-2 transition-colors ${
              tab === t.id
                ? 'border-ink-primary text-ink-primary font-medium'
                : 'border-transparent text-ink-tertiary hover:text-ink-secondary'
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      <div className="px-6 pb-6">
        {tab === 'fluxo' && <FluxoCaixaPage />}
        {tab === 'transacoes' && <TransacoesPage />}
        {tab === 'importacoes' && <ImportacoesListPage />}
        {tab === 'faturas' && <FaturasListPage />}
        {tab === 'impostos' && <ImpostosPage />}
        {tab === 'reforma' && <SimuladorReformaPage />}
        {tab === 'payouts' && <PayoutsPage />}
        {tab === 'fechamento' && <FechamentoPage />}
      </div>
    </div>
  );
}
